import { PurchasedEnergyType } from '../../generated/graphql'
import { subtractItems } from '../../util/array-utility'
import { CalculatedEnergyCost } from './cost-calculator'

export function subtractProfitsFromCosts(
  electricityCost: CalculatedEnergyCost,
  electricityProfit: CalculatedEnergyCost,
): CalculatedEnergyCost {
  if (!electricityProfit.chartValues) {
    return electricityCost
  }
  return {
    energyType: PurchasedEnergyType.Electricity,
    baseValue: electricityCost.baseValue - electricityProfit.baseValue,
    chartValues: subtractItems(
      electricityCost.chartValues,
      electricityProfit.chartValues,
    ),
  }
}
